import { Controller } from "stimulus";

// Lists the states behind one option of a payer profile field, opened from
// the option's summary row or from its bar in the chart (which dispatches
// payer-profile-option-selected with the option key).
//
// The rows follow the chart's By States / By Lives toggle (announced as
// payer-profile-measure-changed): alphabetical by default, most lives first
// under By Lives.
export default class extends Controller {
  static targets = ["modal", "rows"];

  connect() {
    document.addEventListener("turbolinks:before-cache", this.close);
  }

  disconnect() {
    document.removeEventListener("turbolinks:before-cache", this.close);
  }

  open(event) {
    this.show(event.currentTarget.dataset.optionKey);
  }

  openFromChart(event) {
    this.show(event.detail.key);
  }

  show(key) {
    this.close();
    this.modalTargets.find(modal => modal.dataset.optionKey === key)?.classList.remove("hidden");
  }

  // An arrow function so it can also be the before-cache listener: otherwise
  // Turbolinks snapshots the open list and Back brings it up again.
  close = () => {
    this.modalTargets.forEach(modal => modal.classList.add("hidden"));
  };

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  sortRows(event) {
    const byLives = event.detail.measure === "lives";
    const byName = (a, b) => a.dataset.stateName.localeCompare(b.dataset.stateName);

    this.rowsTargets.forEach(rows => {
      const sorted = [...rows.children].sort((a, b) =>
        byLives ? Number(b.dataset.lives) - Number(a.dataset.lives) || byName(a, b) : byName(a, b),
      );

      rows.append(...sorted);
    });
  }
}
